import { buildElectionDefinitionQuery } from './election-api/buildElectionQuery'
import { buildSubscriptionOfferDefinition } from './subscription-offer/buildSubscriptionOfferQuery'

// A single object responsible for exposing all available queries for use in useQuery hooks.
export const queries = {
    'election-api': {
        definition: buildElectionDefinitionQuery,
    },
    'subscription-offer-api': {
        definition: buildSubscriptionOfferDefinition,
    },
}
